import { jsx as t } from "react/jsx-runtime";
import { c as d } from "./index-BNmRGtA6.js";
import { c as p } from "./clsx-OuTLNxxd.js";
import './Badge.css';const c = "_badge_ihhup_16", m = "_primary_ihhup_26", h = "_secondary_ihhup_32", u = "_error_ihhup_38", z = "_isRound_ihhup_51", s = {
  badge: c,
  primary: m,
  secondary: h,
  error: u,
  "size-xs": "_size-xs_ihhup_44",
  isRound: z,
  "size-s": "_size-s_ihhup_56",
  "size-m": "_size-m_ihhup_68",
  "size-l": "_size-l_ihhup_82"
}, y = d(s.badge, {
  variants: {
    isRound: {
      true: s.isRound
    },
    size: {
      xs: s["size-xs"],
      s: s["size-s"],
      m: s["size-m"],
      l: s["size-l"]
    },
    variant: {
      primary: s.primary,
      secondary: s.secondary,
      error: s.error
    }
  },
  defaultVariants: {
    isRound: !1,
    size: "m",
    variant: "primary"
  }
}), b = ({
  children: r,
  className: i,
  isRound: a,
  size: e,
  style: o,
  variant: _,
  ...n
}) => /* @__PURE__ */ t(
  "span",
  {
    className: p(y({ isRound: a, size: e, variant: _ }), i),
    "data-cxy-name": "badge",
    style: o,
    ...n,
    children: r
  }
);
export {
  b as B
};
